import { Emoticon } from "@/extensions/obituary/types";

const emoticons: Emoticon[] = [
  {
    code: ":heart:",
    name: "Hjärta",
    char: "\u2665",
    image: "heart.png",
  },
  {
    code: ":heart-outline:",
    name: "Konturerat Hjärta",
    char: "\u2661",
    image: "heart-outline.png",
  },
  {
    code: ":red-heart:",
    name: "Rött Hjärta",
    char: "\u2665",
    image: "red-heart.png",
  },
  {
    code: ":red-heart-outline:",
    name: "Vitt Hjärta",
    char: "\u2661",
    image: "red-heart-outline.png",
  },
  {
    code: ":dagger:",
    name: "Dolk",
    char: "\u2020",
    image: "dagger.png",
  },
  {
    code: ":latin_cross:",
    name: "Kors",
    char: "\u271D",
    image: "cross.png",
  },
  {
    code: ":latin_cross-outline:",
    name: "Konturerat Kors",
    char: "\u271D",
    image: "cross-outline.png",
  },
  {
    code: ":latin_cross-3d:",
    name: "Kors 3D",
    char: "\u271E",
    image: "cross-outline-3d.png",
  },
  {
    code: ":asterisk:",
    name: "Asterisk",
    char: "︎*",
    image: "asterisk.png",
  },
  {
    code: ":candle:",
    name: "Stearinljus",
    char: "\uD83D\uDD6F\uFE0F",
    image: "candle.png",
  },
  {
    code: ":paw_prints:",
    name: "Tassavtryck",
    char: "\uD83D\uDC3E",
    image: "paw-prints.png",
  },
];

export default emoticons;
